import { IX10Configuration } from "./types";

/** Poll fast only while something is about to change; jcore learns delivery from the unit's next heartbeat. */
export const nextPollDelayMs = (
  configuration: IX10Configuration | undefined,
  msSinceStart: number,
  hidden: boolean
): number => {
  if (hidden) {
    return 60000;
  }
  if (!configuration) {
    return 5000;
  }
  const inFlight = configuration.inFlight?.status;
  if (inFlight === "PENDING" || inFlight === "SENT") {
    // jcore pings the unit 10 s after a publish; its heartbeat confirms delivery within seconds.
    return 3000;
  }
  if (configuration.blockedReason === "BUSY") {
    return Math.max(1000, (configuration.retryAfterSeconds || 1) * 1000);
  }
  if (!configuration.online.verified && msSinceStart < 45000) {
    // Waiting for the heartbeat that answers the ping sent when the tab opened.
    return 3000;
  }
  if (inFlight === "DELIVERED") {
    // A fail-mode change is confirmed by the unit's warnings, refreshed every 10 minutes.
    return 10000;
  }
  return 15000;
};

/** After a manual ping, how often and how long to look for the heartbeat that answers it. */
export const PING_FOLLOW_UP = { intervalMs: 3000, attempts: 10 };
